import React from "react";
import Headroom from "react-headroom";
import "./Header.css";
import {greeting} from "../../portfolio";

function Header() {
  return (
    <Headroom>
      <header className="header">
        <a href="" className="logo">
          <img className="logo1" alt="conductv logo" src={require("../../assets/images/conductv.jpg")}></img>
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label className="menu-icon" htmlFor="menu-btn">
          <span className="navicon"></span>
        </label>
        <ul className="menu">
          <li>
            <a href="#about">About</a>
          </li>
          <li>
            <a href="#featuredproducts">Featured Products</a>
          </li>
          <li>
            <a href="#contact">Contact</a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
